import { IonRow, IonCol, IonIcon, IonLabel } from "@ionic/react";
import { basketOutline, removeOutline, addOutline } from "ionicons/icons";
import React from "react";
import { Product, ProductType } from "@core/types";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";
import classNames from "classnames/bind";

import styles from "./NewListViewProduct.module.scss";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useProductCardActions } from "../../../../../providers/useProductActions";
import { useTranslation } from "react-i18next";

interface PriceAndCartProps {
  product: Product;
}

const cx = classNames.bind(styles);

const PriceAndCart = ({ product }: PriceAndCartProps) => {
  const { cartProductsMap } = useCartData();
  const { addToCart, showProductDetail, removeProductFromCart } = useProductCardActions();
  const { t } = useTranslation();
  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;
  const priceHtml = useCreatePriceMarkup(product);

  const isDisabledToAdd = !product?.purchasable || cartQuantity === product.stockQuantity;

  return (
    <IonRow className={cx("productBasket", "ion-hide-sm-up")}>
      {(product.stockQuantity > 0 || product.type === ProductType.VARIABLE) && (
        <IonCol sizeSm="12">
          <p className={cx("price ellipsis", styles.price)} dangerouslySetInnerHTML={priceHtml}></p>
        </IonCol>
      )}
      {/* LIST-FOR-WISH PRODUCT VIEW */}
      {/* TODO: basket icon and counter*/}
      <IonCol sizeSm={"12"} className={cx("productBasketWrapper")}>
        {!cartQuantity ? (
          <div>
            {product.stockQuantity > 0 ? (
              <div
                className={cx("ion-text-center ion-no-padding leading-none", {
                  disabled: isDisabledToAdd,
                })}
                onClick={(e) => {
                  addToCart(product);
                  e.stopPropagation();
                }}
              >
                <IonIcon icon={basketOutline} className={cx("productBasketIcon")} />
              </div>
            ) : (
              <div
                className={cx("ion-text-center ion-no-padding")}
                onClick={(e) => {
                  showProductDetail(product.id);
                  e.stopPropagation();
                }}
              >
                {product.stockStatus === "instock" ? (
                  <IonIcon icon={basketOutline} className={cx("productBasketIcon")} />
                ) : (
                  <span className={cx("out-of-stock")}>{t("Out of Stock")}</span>
                )}
              </div>
            )}
          </div>
        ) : (
          <IonRow className={cx("quantityCounter")} onClick={(e) => e.stopPropagation()}>
            <IonCol
              size="3"
              className="ion-text-center ion-no-padding"
              onClick={() => removeProductFromCart(product.id)}
            >
              {product.stockStatus === "instock" && (
                <IonIcon icon={removeOutline} className={cx(styles.icon, styles.removeQuantity)} />
              )}
            </IonCol>
            <IonCol size="6" className={cx("quantityValue")}>
              <IonLabel>{cartQuantity}</IonLabel>
            </IonCol>
            <IonCol
              size="3"
              className={cx("ion-text-center ion-no-padding", {
                disabled: isDisabledToAdd,
              })}
              onClick={() => {
                addToCart(product);
              }}
            >
              {product.stockStatus === "instock" && (
                <IonIcon icon={addOutline} className={cx(styles.icon, styles.addQuantity)} />
              )}
            </IonCol>
          </IonRow>
        )}
      </IonCol>
    </IonRow>
  );
};

export default PriceAndCart;
